import { PostServiceM3 } from "../../ConexionSQL/posts.service";

export class ServiceM3FE {

    public add_proceso_generarFE(PostServiceM3: PostServiceM3, sIDKatios: string,
        jData: any, funcionOK: Function, funcionError: Function) {
        PostServiceM3.postServiceHttpResFullM3("M3FE/add_proceso_generarFE/" + sIDKatios, jData).subscribe(resp => {
            //var oJson = JSON.parse(resp.json());

            funcionOK(resp);
        },
            err => {
                //this.enProceso = false;
                console.error(err.json().Message);
                funcionError(err.json().Message);
            });
    }

    public add_proceso_generarNC(PostServiceM3: PostServiceM3, sIDKatios: string,
        jData: any, funcionOK: Function, funcionError: Function) {
        PostServiceM3.postServiceHttpResFullM3("M3FE/add_proceso_generarNC/" + sIDKatios, jData).subscribe(resp => {
            //var oJson = JSON.parse(resp.json());

            funcionOK(resp);
        },
            err => {
                //this.enProceso = false;
                console.error(err.json().Message);
                funcionError(err.json().Message);
            });
    }

    public async addProcesoGenerarFEAsync(PostServiceM3: PostServiceM3, sIDKatios: string, jData: any) {
        let json;
        let resp;

        try {
            resp = PostServiceM3.postServiceHttpResFullM3("M3FE/add_proceso_generarFE/" + sIDKatios, jData).toPromise();
            json = JSON.parse(resp)
            return json;
        }
        catch{
            return null;
        }
    }

    public generarCartaPorte(PostServiceM3: PostServiceM3, sIDKatios: string, idm3: string,
        jData: any, funcionOK: Function, funcionError: Function) {
        PostServiceM3.postServiceHttpResFullFEMX("FEMX/generarCartaPorte/" + sIDKatios + "/" + idm3, jData).subscribe(resp => {
            //var oJson = JSON.parse(resp.json());

            funcionOK(resp);
        },
            err => {
                //this.enProceso = false;
                console.error(err.json().Message);
                funcionError(err.json().Message);
            });
    }

    async getInfoFacturaElectronica(PostServiceM3: PostServiceM3, id_katios: string) {
        var Info;
        var data = { 'idKatios': id_katios.trim() };
        Info = await PostServiceM3.getWithBodyM3('M3FE/getInfoFacturaElectronica', data).toPromise()
        return JSON.parse(Info)
    }

    async getHtmlFromFE(PostServiceM3: PostServiceM3, idKatios: string, idM3: string) {
        let resp;
        let data = { 'idM3': idM3 };
        resp = await PostServiceM3.getWithBodyM3('M3FE/getHtmlFromFE/' + idKatios, data).toPromise()

        return resp;
    }

    async IU_InfoFacturaElectronica(PostServiceM3: PostServiceM3, id_katios: string, oFactura: any, uTActivo: string, uNActivo: string) {
        var Info;
        var data = { 'idKatios': id_katios.trim(), 'oFactura': oFactura, 'uTActivo': uTActivo, 'uNActivo': uNActivo };
        Info = await PostServiceM3.postServiceHttpResFullM3('M3FE/IU_InfoFacturaElectronica', data).toPromise()
        return Info
    }

    public delInsSeriesxUbic(PostServiceM3: PostServiceM3, sIDKatios: string,
        jData: any, funcionOK: Function, funcionError: Function) {
        PostServiceM3.postServiceHttpResFullM3("M3FE/delInsSeriesxUbic/" + sIDKatios, jData).subscribe(resp => {
            //var oJson = JSON.parse(resp.json());        
            funcionOK(resp);
        },
            err => {
                //this.enProceso = false;
                funcionError(JSON.parse(JSON.parse(err["_body"]).Message).RESPUESTA["0"]);
            });
    }
}